import styled from "styled-components";

const MobileInputWrapper = styled.div`
  display: flex;
  .prefix {
    justify-content: center;
    align-items: center;
    display: flex;
    color: #6b47f5;
    border: 1px solid #ced4da;
    // border-right: none;
    padding: 7px;
    font-weight: bold;
    font-family: "Bliss2" !important;
  }
  .prefix-stc {
    color: #4f008c;
    justify-content: center;
    align-items: center;
    display: flex;
    border: 1px solid #ced4da;
    // border-right: none;
    padding: 7px;
    font-weight: bold;
    font-family: "Bliss2" !important;
  }
`;

export default MobileInputWrapper;
